<template>
<div class="report-page" :class="{yellow: styleType == 1, blue: styleType == 2, gray: styleType == 3}">
    <div hidden v-title>检测报告</div>
   <header :style="{background: 'url('+ bgPaths[data.weathertype - 1] +') 0 0 / 100% 100%'}">
        <img class="weather-bg" :src="bgPaths[data.weathertype - 1]" alt="">
      <div @click="toReportDetail" class="images-wrapper">
        <img class='doctor' src="../assets/images/report/doctor.png" alt="">
        <div class="weather-info">
          <img src="../assets/images/logo.png" alt="" class="logo">
          <div class="temp">
            <span class="temp-num">{{ data.temp }}°</span>
            <p class="wheather-status"><img :src="iconPaths[data.weathertype - 1]" alt=""><span>{{data.weather}}</span></p>
          </div>
          <div class="geo">
            <p><img src="../assets/images/weather-icon/icon-geo.png" alt=""><span>{{data.city}}</span></p>
            <p><img src="../assets/images/weather-icon/icon-noun.png" alt=""><span>{{data.humidity}}%</span></p>
            <p><img src="../assets/images/weather-icon/icon-uv.png" alt=""><span>{{UVLevel}}</span></p>
          </div>
        </div>
      </div>
    </header>

    <section>
      <p class="title">温馨提示：</p>
      <div class="content">{{ data.content }}</div>
    </section>

    <section>
      <img class="img-title" :src="titlePKPaths[styleType - 1]" alt="">
      <div class="pk-wrapper">
        <canvas id="pk-process"></canvas>
        <div class="pk-start"> <img :src="data.avatar || ''" alt="" /></div>
        <!-- <img class="pk-bottom" src="../assets/images/pk/pk-bottom.png" alt=""> -->
        <img class="pk-end" :src="data.starimage || ''" alt="">
        <div class="message-wrapper">
          <p>{{ data.starname }}</p>
          <p>{{ data.message }}</p>
          <button @click="getPk">继续PK</button>
        </div>
      </div>
    </section>

    <section>
      <img class="img-title" :src="titleTestPaths[styleType - 1]" alt="">
      <div class="report-info-item" v-for="info in data.datalist" :key="info.type">
        <img :src="verbPaths[String(info.type) + '-' + String(info.level)]" alt="" />
        <div class="info">
          <p class="info-title">{{ info.name }}</p>
          <div class="info-content">{{ info.content }}</div>
        </div>
      </div>
    </section>
    <div class="person-number" :style="{background : showPersonNum ? 'rgba(0,0,0,0.3)' :'none'}">
      <span :style="{display: showPersonNum ? 'inline-block':'none'}">当前检测人数已达：<span style="color: red">{{ personNum }}</span> 人</span>
      <span class="arrow" :class="{hidden: !showPersonNum}" @click="showPersonNum = !showPersonNum"></span>
    </div>
    <!-- <router-link :to="{path: '/Report/MedicalInfo', query: {id, sign}}"></router-link> -->
    <button class="fix-bottom-button" @click="toReportDetail" :style="{background: 'url('+ bottomBottonBgPath[styleType - 1]} +')'">
      <img :src="bottomBottonBgPath[styleType - 1]" alt="">
    </button>
    <div v-if="showMask" :style="{background: 'url(' + maskPath +') 0 0 / 100% 100%'}" class="mask">
      <button class="mask-close" @click="showMask = false"></button>
    </div>
  </div>
</template>
<style lang="stylus">
@keyframes heart-run{
  0% {
    opacity: 1;
    transform: translate(0);
  }
  50% {
    transform: rotate(-10deg) translate(-5px, -25px);
    opacity .8
  }
  100% {
    transform: rotate(20deg) translate(10px, -50px);
    opacity: 0;
  }
}

span.heart{
  animation: heart-run 3s ease 0s 1;
  animation-fill-mode: forwards
  position absolute
  left 60%
  top 0
  display block
  width 20px
  height 20px
  line-height 20px
  font-size 9px !important
  text-align center
  color #ffffff
  background url('../assets/images/report/little-heart.png') 0 0 / 100% 100%;
}
</style>

<style lang="stylus" scoped>
theme(selector, colors){
  &.{selector}{
    background: colors;
  }
}

#app{
  height: 0;
}

.person-number{
  position relative
  .arrow{
    display: inline-block;
    width: 15px;
    height: 100%;
    vertical-align: middle;
    background: rgba(0, 0, 0, 0.5);
    margin: -1px 0 0 10px;
    border-radius 0 10px 10px 0

    &:after{
      content: '';
      border-top: 1px solid #ffffff;
      border-left: 1px solid #ffffff;
      width: 7px;
      height: 7px;
      display: block;
      transform: rotate(-45deg);
      position: absolute;
      top: calc(50% - 4px);
      // right 4px
      right: 2px;
    }

    &.hidden:after{
      transform: rotate(135deg);
      right 6px
    }
  }
}

.mask{
  position: fixed;
  top: 0;
  // background url('../assets/images/mask.png') 0 0 / 100% 100%
  width: 100%;
  margin: 0 auto;
  max-width: 720px;
  height: 100vh;
  z-index: 100;

  button{
    width: 100px;
    height: 50px;
    position: absolute;
    right: 5vw;
    top: 18vh;
  }
}

.report-page{
  position: relative;
  padding-bottom: 50px;
  margin: 0 auto;
  max-width: 720px;
  // z-index: -1;
  overflow: hidden;
  theme('blue', #e8f6ff);
  theme('gray', #f7f7f7);
  theme('yellow', #fff9e9);
}

.pk-wrapper {
  width: 350px;
  margin: 0 auto;
  height: 200px;
  position: relative;
  top: -30px;

  canvas {
    // position: absolute;
    position: relative;
    display: block;
    margin: 0 auto;
    width: 90%;
    height: 150px;
    z-index: 1;
  }

  img {
    outline: none;
    top: 25px;
  }

  .message-wrapper {
    text-align: center;
    margin-top: -50px;
    line-height: 30px;
    font-size: 16px;

    p:nth-of-type(1) {
      font-size: 25px;
      font-weight: 400;
    }

    button {
      color: #666;
      margin-top: 15px;
      padding: 5px 20px;
      border-radius: 20px;
      background: #eee;
      box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    }
  }

  .pk-start {
    position: absolute;
    display: inline-block;
    width: 80px;
    height: 80px;
    // padding: 5px;
    // border-image: linear-gradient(to right, #ffe04f, #f39107) 10;
    // border-image: url('../assets/images/pk/person-left.png') 30;
    // border: 5px solid #eee;
    background: url('../assets/images/pk/person-left.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    left: 0px;
    top: 25px;
    z-index: 2;

    img {
      position: absolute;
      left: 2px;
      top: 2px;
      width: 75px;
      height: 75px;
      padding: 5px;
      border-radius: 50%;
      z-index: 2;
    }
  }

  .pk-bottom {
    width: 70%;
    top: 0;
    left: 15%;
    z-index: 0;
  }

  .pk-end {
    position: absolute;
    top: 25px;
    width: 75px;
    height: 75px;
    right: 0px;
    z-index: 2;
    border-radius: 50%;
    background-color: rgb(161, 215, 231);
    border: 5px solid rgb(161, 215, 231);
  }
}

.person-number {
  padding: 0 0 0 10px;
  border-radius: 24px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  bottom: 15%;
  transform: translateX(20px);
  line-height: 24px;
  height: 24px;
  margin: 0;
}

header {
  .images-wrapper {
    padding: 7vh 5% 2vh;
    margin: 0 auto;
    max-width: 568px;
  }

  .weather-bg {
    width: 100%;
    position: absolute;
    z-index: -1;
  }

  .doctor {
    width: calc(236 / 720 * 100%);
    margin-left: 10px;
  }

  .weather-info {
    display: inline-block;
    vertical-align: top;
    float: right;
    padding-bottom: 5vh;
    width: calc(100% - (236 / 720 * 100%) - 10px);
  }

  .logo {
    display: block;
    width: 150px;
    margin: 0 auto;
  }

  .temp {
    margin-top: 40px;
    padding-right: 10px;
    width: calc(100% - 125px);
    color: #2b2b2b;
    display: inline-block;
    position: relative;
    text-align: center;
    vertical-align: middle;

    .temp-num {
      font-size: 60px;
      padding: 0;
      margin: 0;
      line-height: 0;
    }

    p {
      margin-top: 10px;
      line-height: 30px;
      height: 30px;

      span {
        vertical-align: top;
      }
    }

    .wheather-status span {
      margin-left: 14px;
    }

    span {
      font-size: 16px;
    }
  }

  .geo {
    width: 120px;
    display: inline-block;
    vertical-align: middle;
    padding-left: 15px;
    margin-top: 20px;
    border-left: 1px solid #ccc;

    p {
      font-size: 16px;
      color: #2b2b2b;
      line-height: 26px;

      &:nth-of-type(1) {
        font-size: 20px;
        margin-bottom: 14px;
      }

      img {
        width: 20px;
        vertical-align: middle;
      }

      span {
        margin-left: 14px;
      }
    }
  }
}

section {
  position: relative;
  font-size: 14px;
  width: calc(100% - 20px);
  margin: 0 auto;

  .img-title {
    width: calc(265 / 700 * 100%);
    margin: 0 auto;
    display: block;
    transform: translateY(-50%);
  }

  &:nth-of-type(1) {
    padding: 18px 20px;
    background: #ffffff;
    margin: 20px auto 0;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
    border-radius: 10px;

    .title {
      font-size: 18px;
      color: #454545;
    }

    .content {
      margin-top: 12px;
      font-size: 14px;
      color: #666666;
      line-height: 30px;
    }
  }

  &:nth-of-type(2) {
    border: 2px solid #fff;
    border-radius: 10px;
    margin-top: 76px;
    padding-bottom: 20px;
  }

  &:nth-of-type(3) {
    border: 2px solid #fff;
    margin: 10px;
    border-radius: 10px;
    margin-top: 76px;
    padding: 0 0 50px;

    .report-info-item {
      display: flex;
      align-items: center;

      + .report-info-item {
        margin-top: 35px;
      }

      .info {
        width: 50%;
        letter-spacing: 0;
        vertical-align: middle;
        padding: 0 calc(60px / 720px);
      }

      .info-title {
        font-size: 18px;
        line-height: 3;
        color: #2b2b2b;
        font-weight: 400;
        padding: 0 10px;
      }

      .info-content {
        font-size: 14px;
        color: #2f2f2f;
        line-height: 21px;
        line-height: 1.5;
        padding: 0 10px;
      }

      img {
        width: 50%;
        vertical-align: middle;
        padding: 0.5rem;
      }

      &:nth-of-type(2n) {
        flex-direction: row-reverse;
      }
    }
  }
}

.fix-bottom-button {
  position: fixed;
  bottom: 0;
  display: block;
  width: 100%;
  max-width: 720px;
  background-size: 100% auto !important;
  height: 50px;
  z-index: 100;
  padding: 0;

  img {
    width: 100%;
  }
}
</style>
<script>
export default {
  name: 'WXReport',
  data () {
    return {
      data: {},
      timer: undefined,
      showMask: true,
      showPersonNum: true,
      maskPath: require('../assets/images/report/mask.png'),
      personNum: 0,
      isShowPersonNum: false,
      id: 0,
      sign: '',
      tmpKey: '',
      bgPaths: [],
      iconPaths: [],
      verbPaths: {},
      titlePKPaths: [],
      titleTestPaths: [],
      bottomBottonBgPath: [],
      bottomBottonBgDownPath: []
    }
  },
  computed: {
    styleType () {
      switch (this.data.weathertype) {
        case 1:
        case 17:
          return 1
        case 2:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
          return 2
        default:
          return 3
      }
    },
    UVLevel () {
      return (
        [undefined, '0-2 最弱', '3-4 弱', '5-6 中等', '7-9 强', '10+ 最强'][this.data.uv - 1] || '未知'
      )
    }
  },
  async created () {
    const wx = require('weixin-js-sdk')
    this.$nextTick(() => {
      for (let i = 1; i <= 17; i++) {
        this.bgPaths.push(
          require(`../assets/images/weather/weather-bg-${i}.gif`)
        )
        this.iconPaths.push(
          require(`../assets/images/weather-icon/weather-icon-${i}.png`)
        )
      }

      for (let i = 1; i <= 7; i++) {
        for (let j = 1; j <= 4; j++) {
          this.$set(this.verbPaths, String(i) + '-' + String(j), require(`../assets/images/feature/face/${i}-${j}.png`))
        }
      }

      for (let i = 1; i <= 3; i++) {
        this.titlePKPaths.push(
          require(`../assets/images/report/title-pk-${i}.png`)
        )
        this.titleTestPaths.push(
          require(`../assets/images/report/title-test-${i}.png`)
        )
        this.bottomBottonBgPath.push(
          require(`../assets/images/report/bottom-button-${i}.png`)
        )
        this.bottomBottonBgDownPath.push(
          require(`../assets/images/report/bottom-button-${i}-down.png`)
        )
      }
    })
    this.id = this.$route.query.id
    this.sign = this.$route.query.sign

    // https://data.wax-apple.cn/Index/Report/Pifu_play?id=315558&sign=5a8bbbd84b2fec7879a2a14f5b15312b
    let latitude
    let longitude
    try {
      const {appId, timestamp, noncestr, signature} = (await this.$axios.get(
        '/Index/Report/GetWechatConfig',
        {
          params: {
            checkid: this.id,
            sign: this.sign
          }
        }
      )).data.data[0]
      await new Promise((resolve, reject) => {
        wx.config({
          appId,
          timestamp,
          nonceStr: noncestr,
          signature,
          jsApiList: ['getLocation']
        })
        wx.ready(() => {
          wx.getLocation({
            type: 'gcj02',
            success (res) {
              latitude = res.latitude
              longitude = res.longitude
            },
            complete () {
              resolve()
            }
          })
        })
        setTimeout(() => {
          resolve()
        }, 1000)
      })
    } catch (err) {
    } finally {
      const params = (latitude && longitude) ? {
        id: this.id,
        sign: this.sign,
        latitude,
        longitude
      } : {
        id: this.id,
        sign: this.sign
      }
      const response = await this.$axios.get('/Index/Report/Pifu_play', {
        params
      })

      this.data = response.data

      this.personNum = this.data.usercount // 人数统计

      const ctx = document.querySelector('#pk-process').getContext('2d')
      ctx.beginPath()
      ctx.strokeStyle = 'rgb(161, 215, 230)'
      ctx.lineWidth = 30
      ctx.arc(150, 260, 230, Math.PI * 43 / 32, Math.PI * 53 / 32)
      ctx.stroke()

      ctx.beginPath()
      ctx.strokeStyle = 'rgb(84, 204, 226)'
      ctx.arc(
        150,
        260,
        230,
        Math.PI * 43 / 32,
        Math.PI * (43 / 32 + 10 / 32 * Number(this.data.value) / 100)
      )
      ctx.stroke()
    }
    // 报告信息
    this.timer = setInterval(async () => {
      const personData = await this.$axios.get('/Index/Report/OnlineNumber', {
        params: {
          sign: this.sign,
          checkid: this.id
        }
      })
      let {add, value} = personData.data.data[0]
      this.personNum = value
      // add += 1 // test
      if (add > 0) {
        const dom = document.querySelector('.person-number')
        const heartdom = document.createElement('span')
        heartdom.innerText = '+' + add
        heartdom.classList.add('heart')
        dom.appendChild(heartdom)
        setTimeout(() => dom.removeChild(heartdom), 3000)
      }
    }, 30000)
  },
  methods: {
    // 改变星星
    changeStar (val) {
      this.stars = val
    },
    async getPk () {
      const response = await this.$axios.get('/Index/Report/Contrast', {
        params: {
          checkid: this.id,
          sign: this.sign
        }
      })
      const {value, message, starname, starimage} = response.data.data
      this.data.value = value
      this.data.message = message
      this.data.starname = starname
      this.data.starimage = starimage
      const ctxdom = document.querySelector('#pk-process')
      const ctx = ctxdom.getContext('2d')
      ctx.clearRect(0, 0, 300, 150)
      this.$nextTick(() => {
        ctx.beginPath()
        ctx.strokeStyle = 'rgb(161, 215, 230)'
        ctx.lineWidth = 30
        ctx.arc(150, 260, 230, Math.PI * 43 / 32, Math.PI * 53 / 32)
        ctx.stroke()
        ctx.beginPath()
        ctx.strokeStyle = 'rgb(84, 204, 226)'
        ctx.arc(
          150,
          260,
          230,
          Math.PI * 43 / 32,
          Math.PI * (43 / 32 + 10 / 32 * Number(this.data.value) / 100)
        )
        ctx.stroke()
      })
    },
    // 检测报告详情
    toReportDetail () {
      this.$router.push({
        path: '/Report/pifu_profes',
        query: {
          id: this.$route.query.id,
          sign: this.$route.query.sign
        }
      })
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/WXReport.vue